import React, { MouseEvent } from 'react';

interface PriceIconProps {
  className?: string;
  onClick?: (event: MouseEvent) => void;
}

const PriceIcon = ({ className, onClick }: PriceIconProps) => {
  return (
    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_2213_7295)">
        <path d="M7.99967 1.33301C4.31967 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31967 14.6663 7.99967 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99967 1.33301ZM7.99967 13.333C5.05967 13.333 2.66634 10.9397 2.66634 7.99967C2.66634 5.05967 5.05967 2.66634 7.99967 2.66634C10.9397 2.66634 13.333 5.05967 13.333 7.99967C13.333 10.9397 10.9397 13.333 7.99967 13.333ZM8.59301 7.39967C7.40634 7.00634 6.83301 6.75967 6.83301 6.13301C6.83301 5.45301 7.57301 5.20634 8.03967 5.20634C8.91301 5.20634 9.23301 5.86634 9.30634 6.09967L10.3597 5.65301C10.2597 5.35967 9.81301 4.37967 8.58634 4.16634V3.33301H7.41967V4.17301C5.68634 4.54634 5.67301 6.07301 5.67301 6.14634C5.67301 7.65967 7.17301 8.08634 7.90634 8.35301C8.95967 8.72634 9.42634 9.06634 9.42634 9.70634C9.42634 10.4597 8.72634 10.7797 8.10634 10.7797C6.89301 10.7797 6.54634 9.53301 6.50634 9.38634L5.39967 9.83301C5.81967 11.293 6.91967 11.6863 7.41301 11.8063V12.6663H8.57967V11.8397C8.92634 11.7797 10.593 11.4463 10.593 9.69301C10.5997 8.76634 10.193 7.95301 8.59301 7.39967Z" fill="#191B1E"/>
      </g>
      <defs>
        <clipPath id="clip0_2213_7295">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PriceIcon;